export class Tab {
    public path: string;
    public name: string;
}
